export function useTaskFormCluster() {
  const addTaskFormClusters = async (store, tasks = [], forms = []) => {
    const show_task_cluster = store.tasks_cluster?.cluster;
    const show_form_cluster = store.forms_cluster?.cluster;
    const cluster_source = 'task_form_count_points';
    const cluster_layers = [
      'task_form_clusters_point',
      'task_form_clusters_count',
      'task_form_unclusters_point',
      'task_form_unclusters_count',
    ];

    if (!store.map)
      return;

    // Remove source and layers
    cluster_layers.forEach((layer) => {
      if (store.map?.getLayer(layer))
        store.map.removeLayer(layer);
    });
    if (store.map?.getSource(cluster_source))
      store.map.removeSource(cluster_source);

    if (!show_task_cluster && !show_form_cluster)
      return;

    // Pick features based on which clustering toggle is enabled.
    // Task only -> tasks count, Form only -> forms count, Both -> combined count.
    const features = [
      ...(show_task_cluster ? tasks : []),
      ...(show_form_cluster ? forms : []),
    ];

    if (!features.length)
      return;

    const turf = (await import('@turf/turf'));

    const points_list = features.reduce((acc, f) => {
      const centroid = turf.centroid(f);
      acc.push({
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: centroid?.geometry?.coordinates,
        },
        item_uid: f.properties.uid,
      });
      return acc;
    }, []);

    const unique_geometries = {};
    points_list.forEach((point) => {
      const coords = JSON.stringify(point.geometry.coordinates); // Serialize coordinates to identify same geometry
      if (!unique_geometries[coords]) {
        unique_geometries[coords] = [];
      }
      unique_geometries[coords].push(point);
    });

    const data = [];

    Object.keys(unique_geometries).forEach((key) => {
      const points = unique_geometries[key];
      // Only add to cluster data if there are 2 or more items at the same location
      if (points.length > 1) {
        data.push({
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: points[0]?.geometry?.coordinates,
          },
          properties: {
            count: points.length,
            item_uids: points.map(p => p.item_uid),
            point_id: crypto.randomUUID(),
          },
        });
      }
    });

    // If no overlapping items, don't create cluster layers
    if (data.length === 0)
      return;

    store.map.addSource(cluster_source, {
      type: 'geojson',
      data: {
        type: 'FeatureCollection',
        features: data,
      },
      cluster: true,
      clusterProperties: {
        totalCount: ['+', ['get', 'count']],
      },
    });

    store.map.addLayer({
      id: 'task_form_clusters_point',
      type: 'circle',
      source: cluster_source,
      filter: ['has', 'point_count'],
      paint: {
        'circle-opacity': 0.8,
        'circle-color': '#344054',
        'circle-radius': [
          'step',
          ['get', 'point_count'],
          20, // Base radius for small clusters
          100, // Radius for medium clusters
          30, // Radius for large clusters
          750, // Radius for very large clusters
          40, // Maximum radius for the largest clusters
        ],
      },
    });
    store.map.addLayer({
      id: 'task_form_clusters_count',
      type: 'symbol',
      source: cluster_source,
      layout: {
        'text-field': '{totalCount}',
        'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'], // Use bold fonts
        'text-size': 12,
      },
      paint: {
        'text-color': '#ffffff',
      },
    });

    // For displaying unclustered data
    store.map.addLayer({
      id: 'task_form_unclusters_point',
      type: 'circle',
      source: cluster_source,
      filter: ['!', ['has', 'point_count']],
      paint: {
        'circle-opacity': 0.8,
        'circle-color': '#344054',
        'circle-radius': 15,
      },
    });
    store.map.addLayer({
      id: 'task_form_unclusters_count',
      type: 'symbol',
      source: cluster_source,
      filter: ['!', ['has', 'point_count']],
      layout: {
        'text-field': ['get', 'count'],
        'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
        'text-size': 12,
      },
      paint: {
        'text-color': '#ffffff',
      },
    });
  };

  return {
    addTaskFormClusters,
  };
}
